<!--
 * @Description: 审核意见弹框组件
 * @Author: sunhuihong gaohc
 * @Date: 2022-05-09 14:01:35
 * @LastEditTime: 2023-11-27 14:14:15
-->
<template>
  <el-dialog width="45%" title="审核意见" @open="initView" :visible.sync="showReviewCommentsDialog"
    center class="review-mgs-dialog" :before-close="handleCancel" append-to-body>
    <el-form :label-position="labelPosition" label-width="90px" :model="ruleForm"
      :rules="rules" ref="ruleForm" style="padding: 0 25px;">
      <el-form-item label="审核结果:" prop="status">
        <el-radio v-model="ruleForm.status" @change="handelStatusChange"
          :disabled="disabled" label="approve">
          通过
        </el-radio>
        <el-radio v-model="ruleForm.status" @change="handelStatusChange"
          :disabled="disabled" label="reject">
          驳回
        </el-radio>
        <div v-if="reviewType == 'mchReview'" class="review-tag">
          <span v-if="ruleForm.status == 'approve'">
            审核通过后，系统将自动提交申请单到微信支付平台
          </span>
        </div>
      </el-form-item>
      <el-form-item label="审核意见:" style="margin-top: 15px" prop="reviewComments">
        <el-input type="textarea" v-model.trim="ruleForm.reviewComments"
					:autosize="{ minRows: 8, maxRows: 8 }">
        </el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer bk-wizard-bottons">
      <el-button @click="handleCancel" size="small" style="width: 80px; margin-right: 30px">
        取 消
      </el-button>
      <el-button type="primary" @click="handleSubmit('ruleForm')" size="small" style="width: 80px">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ["showReviewCommentsDialog", "reviewStatus", "reviewType"],

  data() {
    return {
      labelPosition: "left",
      ruleForm: {
        reviewComments: "",
        status: "approve",
      },
      rules: {
        reviewComments: [
          {
            required: true,
            message: "请填写审核意见",
            trigger: ['blur', 'change'],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择审核结果",
            trigger: "blur",
          },
        ],
      },
      disabled: null, //审核结果标识
    };
  },

  methods: {
    clearData() {
      this.ruleForm.reviewComments = "";
    },

    handleCancel() {
      this.clearData();
      this.$refs.ruleForm.resetFields();
      this.$emit("handle-close-review-comments-dialog", false);
    },

		// 审核意见提交
    handleSubmit(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        // 部分输入法输入后不点击确定的时候能过去验证
        if (!valid) return false;

        this.$emit("handle-review-comments-msg", this.ruleForm.reviewComments,
          this.ruleForm.status);
        this.clearData();
      });
    },

		// 通过驳回按钮组切换
    handelStatusChange(status) {
      this.ruleForm.reviewComments =
        status == "approve" ? "信息完善，审核通过" : "";
    },

    initView() {
      if (this.reviewStatus) {
        this.ruleForm.status = this.reviewStatus;
        this.disabled = true;
      } else {
        this.ruleForm.status = "approve"
        this.disabled = false;
      }
      this.ruleForm.reviewComments = this.ruleForm.status == "approve" ? "信息完善，审核通过" : "";
    },
  },
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 0;
}

.review-tag {
  color: #ff9b29;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
}

.dialog-footer {
  text-align: center;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/ReviewCommentsDialog.vue